
import React from 'react';
import { MessageSquareText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface FeedbackButtonProps {
  onClick: () => void;
}

const FeedbackButton: React.FC<FeedbackButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-6 right-6 z-[90]">
      <button
        onClick={onClick}
        title={t('feedback.button')}
        className="group flex items-center justify-center w-14 h-14 bg-[#0F172A] text-white rounded-full shadow-xl hover:bg-[#3B82F6] transition-all duration-300 hover:scale-110 active:scale-95"
      >
        <MessageSquareText className="w-6 h-6 group-hover:animate-pulse" />
        
        {/* Subtle Tooltip Label (Desktop only) */}
        <span className="absolute right-full mr-4 px-3 py-1.5 bg-[#0F172A] text-white text-xs font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none hidden md:block">
          {t('feedback.button')}
        </span>
      </button>
    </div>
  );
};

export default FeedbackButton;
